import clsx from 'clsx';
import React from 'react';
import NavigateNext from '@mui/icons-material/NavigateNext';
import styles from './ReportBlock.module.scss';
import { Button } from 'tt-ui-lib/core';
import { ReactComponent as DeleteSvg } from '../../../../../../assets/svg/delete.svg';
import { ReactComponent as EditSvg } from '../../../../../../assets/svg/edit.svg';
import { CALC_TYPES } from 'utils/calculatorUtils';
import RenameInput from 'views/ScoreAndReporting/components/ReportRename/ReportRename';

const ReportBlock = ({ props }) => {
  const {
    draft,
    targetWidth,
    calcLogo,
    editId,
    setEditId,
    onProceedDraft,
    onDelete,
    onRenameDraft,
    onViewClick,
    onGenerateClick,
  } = props;

  return (
    <div
      key={draft.id}
      className={clsx(styles.rowWrapper, targetWidth < 940 && styles.shortFormat)}
    >
      <div className={styles.summary}>
        <div className={styles.draftData}>
          <RenameInput
            id={draft.id}
            name={draft.name}
            onEditClick={() => setEditId(editId === draft.id ? null : draft.id)}
            onEditFinish={onRenameDraft}
            isEditing={editId === draft.id}
          />
        </div>
        <div className={clsx(styles.dataBlock, styles.info)}>
          <div className={styles.dataBlock}>
            <div className={styles.container}>
              <p className={styles.dataSecond}>Edited:</p>
              <p className={styles.dataValue}>
                {draft?.updatedAt ? draft.updatedAt.toLocaleDateString() : ''}
              </p>
            </div>
            <div className={styles.container}>
              <p className={styles.data}>Reporting period:</p>
              <p className={styles.dataValue}>
                {draft?.periodReportDate ? draft.periodReportDate.getFullYear() : ''}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={clsx(styles.dataBlock, styles.buttonCont)}>
        <div>
          {!!onDelete && (
            <Button type="icon" onClick={() => onDelete(draft)}>
              <DeleteSvg />
            </Button>
          )}
          <Button type="link" onClick={() => onProceedDraft(draft.id)}>
            Proceed
            <NavigateNext />
          </Button>
        </div>
        {draft.type === CALC_TYPES.CUSTOM_REPORT && (
          <Button style={{ textWrap: 'nowrap' }} onClick={() => onViewClick(draft.id)}>
            View more
          </Button>
        )}
        {draft.type === CALC_TYPES.CUSTOM_FILES && (
          <Button
            style={{ textWrap: 'nowrap' }}
            className={styles.more}
            onClick={() => onGenerateClick()}
          >
            Generate
          </Button>
        )}
      </div>
    </div>
  );
};

export default ReportBlock;
